__turbopack_context__.v({
  "column": "Column-module__zgC-VG__column",
});
